import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  loadingSub: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loadingUrls: Set<string> = new Set<string>();
  public skipIndicator: boolean = false;

  constructor() {}

  setLoading(loading: boolean, url: string): void {
    if(this.skipIndicator){
      this.skipIndicator = false;
      return;
    }

    if (loading) {
      this.loadingUrls.add(url);
      this.loadingSub.next(true);
    } else if (!loading && this.loadingUrls.has(url)) {
      this.loadingUrls.delete(url);
    }

    if (this.loadingUrls.size === 0) {
      this.loadingSub.next(false);
    }
  }
}
